export default __webpack_public_path__ + "static/lutein-prevantivno-corn-5174983ed88bd36f087ab810f8382057.jpg";